import Vue from 'vue'
import App from './App.vue'
import LoadScript from 'vue-plugin-load-script';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/scss/bootstrap.scss'
import './custom.scss'
import VueChartJs from 'vue-chartjs'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

Vue.config.productionTip = false
Vue.use(LoadScript)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


//Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline);
Vue.component('line-chart', {
  extends: VueChartJs.Bar,
  mixins: [VueChartJs.mixins.reactiveProp],
  data: function () {
		return {
			options: {
				scales: {
					yAxes: [{
						ticks: {
							//beginAtZero: true,
							callback: function(value) {
                        return value + ' kWh';
                    },
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: true
				},
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems) {
							return tooltipItems.yLabel + 'kWh';
						}
					}
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 200
			}
		}
	},
	mounted () {
		// this.chartData is created in the mixin
		this.renderChart(this.chartData, this.options)
	}
})

Vue.component('irr-chart', {
  extends: VueChartJs.Line,
  mixins: [VueChartJs.mixins.reactiveProp],
  type: 'line',
  data: function () {
		return {
			options: {
				scales: {
					yAxes: [
					/*{
						id: 'IRR',
						type: 'linear',
						position: 'left',
						ticks: {
							//beginAtZero: true
							callback: function(value) {
                        return value + ' %';
                    }
						},
						gridLines: {
							display: true
						}
					}, */
					{
						id: 'payback',
						type: 'linear',
						position: 'right',
						ticks: {
							//beginAtZero: true,
							callback: function(value) {
                        return value + ' år';
                    }
						},
						gridLines: {
							display: false
						}
					}],
					xAxes: [{
						ticks: {
							//beginAtZero: true
							callback: function(value) {
                        return value + ' kW';
                    }
						},
						gridLines: {
							display: true
						}
					}]
				},
				legend: {
					display: true
				},
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index] + ' kW'; },
						label: function(tooltipItems) {
							/*
							if(tooltipItems.datasetIndex === 0){
							return tooltipItems.yLabel + ' %';
							} else {
								*/
							return tooltipItems.yLabel + ' år';
							/*}*/
						}
					}
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 100
			}
		}
	},
	mounted () {
		// this.chartData is created in the mixin
		//console.log(this);
		//console.log(this);
		this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
		this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
		this.gradient.addColorStop(0, 'rgba(25, 135, 84, 1)')
this.gradient.addColorStop(0.5, 'rgba(25, 135, 84, 0.25)');
this.gradient.addColorStop(1, 'rgba(25, 135, 84, 0)');
 
this.gradient2.addColorStop(0, 'rgba(204, 0, 3, 1)')
this.gradient2.addColorStop(0.5, 'rgba(204, 0, 3, 0.25)');
this.gradient2.addColorStop(1, 'rgba(204, 0, 3, 0)');
		this.renderChart(this.chartData, this.options)
	}
})



new Vue({
  render: h => h(App),
  data() {
    return {
      message: 'xx',
      //datacollection: null,
      irrChartData: null,
	  annualDemand: 12000
    }
  },
  created(){
     this.fillData()
    //console.log('main.js-created');
  },
  methods: {
		fillData () {
        this.datacollection = {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            }
          ],
		  options: {
            scales: {
              yAxes: [{
                ticks: {
							callback: function(value) {
                        return value + ' kWh';
                    },
                  beginAtZero: true
                }
              }]
            },
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						title: function (tooltipItem, data) { return data.labels[tooltipItem[0].index] + ' kWh'; },
						label: function(tooltipItems) {
							return tooltipItems.yLabel + ' kWh';
						}
					}
				},
            responsive: true,
            maintainAspectRatio: false
          }
        },
        this.irrChartData = {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
            }
          ]}
      },
    getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
	},
	mounted() {
    //console.log('main.js-mounted');
  }
}).$mount('#app')
